// Copyright (C) 2019 tribe29 GmbH - License: Check_MK Enterprise License
// This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
// conditions defined in the file COPYING, which is part of this source code package.

import * as ajax from "ajax";
import * as forms from "forms";

//#.
//#   .-Designer--------------------------------------------------------------.
//#   |               ____            _                                       |
//#   |              |  _ \  ___  ___(_) __ _ _ __   ___ _ __                 |
//#   |              | | | |/ _ \/ __| |/ _` | '_ \ / _ \ '__|                |
//#   |              | |_| |  __/\__ \ | (_| | | | |  __/ |                   |
//#   |              |____/ \___||___/_|\__, |_| |_|\___|_|                   |
//#   |                                 |___/                                 |
//#   +-----------------------------------------------------------------------+
//#   |  Code for the interactive graph designed                              |
//#   '-----------------------------------------------------------------------'

function count_graph_designer_checked_checkbox() {
    var o_form = document.getElementById("form_graph");
    var childs = o_form.getElementsByTagName("input");
    let sum = 0;
    for (var i = 0; i < childs.length; i++) {
        if (childs[i].type == "checkbox") {
            if (childs[i].checked) sum += 1;
        }
    }
    return sum;
}

export function fix_graph_designer_operator_visibiliy() {
    toggle_graph_designer_block_visibility(
        "graph_designer_operators",
        count_graph_designer_checked_checkbox() >= 2
    );
}

export function fix_graph_designer_transform_visibiliy() {
    toggle_graph_designer_block_visibility(
        "graph_designer_transformations",
        count_graph_designer_checked_checkbox() == 1
    );
}

export function toggle_graph_designer_block_visibility(elementid, visible) {
    let block = document.getElementById(elementid);
    let block_off = document.getElementById(elementid + "_off");
    if (visible) {
        block.style.display = "";
        block_off.style.display = "none";
    } else {
        block.style.display = "none";
        block_off.style.display = "";
    }
}

/* ValueSpec MetricChoice
This function is called for several purposes:
1. Updating the list of services when the host is changed
2. Updating the list of metrics when the service is changed
3. Submitting the form when something is changed in an existing
   metric (not [Add metric] case) *and* all four choices
   have a valid value.
*/

var g_metric_choice_ajax = null;

export function metric_choice_changed(type_name, varprefix, o_input) {
    var o_metric_choice = document.getElementById("metricchoice_" + varprefix);
    var o_host = o_metric_choice.childNodes[1];
    var o_service = document.getElementById(varprefix + "_service");
    var o_metric = document.getElementById(varprefix + "_metric");
    var o_type = document.getElementById(varprefix + "_type");

    // Do completion / updating of selections according to
    // changed host/service. but not for changes in the metric
    // or cf.
    if (o_input !== o_type && o_input !== o_metric) {
        var url =
            "ajax_" +
            type_name +
            "_choice.py?" +
            "varprefix=" +
            encodeURIComponent(varprefix) +
            "&" +
            varprefix +
            "_host=" +
            encodeURIComponent(o_host.value) +
            "&" +
            varprefix +
            "_service=" +
            encodeURIComponent(o_service.value) +
            "&" +
            varprefix +
            "_metric=" +
            encodeURIComponent(o_metric.value) +
            "&" +
            varprefix +
            "_type=" +
            encodeURIComponent(o_type.value);

        if (g_metric_choice_ajax !== null) g_metric_choice_ajax.abort();

        g_metric_choice_ajax = ajax.call_ajax(url, {
            response_handler: handle_metric_choice_changed_response,
            handler_data: varprefix,
        });
    }

    check_submit_graph_designer_form(varprefix, o_metric_choice);
}

function handle_metric_choice_changed_response(varprefix, response) {
    if (!response) return; // Do not submit - host name is incomplete

    var o_metric_choice = document.getElementById("metricchoice_" + varprefix);
    o_metric_choice.innerHTML = response;
    check_submit_graph_designer_form(varprefix, o_metric_choice);
}

// Modify existing formula? Submit, but only if
// Service and metric selection are not empty.
function check_submit_graph_designer_form(varprefix) {
    if (varprefix.indexOf("formula_") !== 0) return;

    var o_service = document.getElementById(varprefix + "_service");
    var o_metric = document.getElementById(varprefix + "_metric");
    if (o_service.value && o_metric.value) submit_graph_designer_form();
    else forms.enable_select2_dropdowns();
}

export function submit_graph_designer_form() {
    document.getElementById("form_graph").submit();
}
